export interface ShortcutRow {
  keys: string[];
  label: string;
}

export interface ShortcutGroup {
  heading: string;
  rows: ShortcutRow[];
}

export interface ShortcutsCtx {
  /** Admin mode is on (admin affordances are drawn). */
  isAdmin?: boolean;
  /** User may enter admin mode -- true even when admin mode is off. */
  isAdminUser?: boolean;
  keyboardShortcutsEnabled?: boolean;
}

/**
 * Pure function — returns the shortcut groups available on the given page.
 * Dynamic groups (e.g. curation action keys that change per status tab) are
 * registered separately via ShortcutsProvider and appended at render time.
 */
export function getPageShortcuts(pathname: string, ctx: ShortcutsCtx = {}): ShortcutGroup[] {
  const { isAdmin = false, isAdminUser = isAdmin, keyboardShortcutsEnabled = true } = ctx;
  const groups: ShortcutGroup[] = [];

  if (isAdminUser) {
    groups.push({
      heading: 'Global',
      rows: [
        ...(isAdmin ? [{ keys: ['⌘K'], label: 'Add article' }] : []),
        { keys: ['a'], label: isAdmin ? 'leave admin mode' : 'enter admin mode' },
      ],
    });
  }

  if (pathname === '/' || pathname.startsWith('/feeds/')) {
    groups.push({
      heading: 'Search & feeds',
      rows: [
        { keys: ['/'], label: 'search' },
        { keys: ['f'], label: 'switch feed' },
        { keys: ['?'], label: 'show shortcuts' },
      ],
    });
  }

  if (keyboardShortcutsEnabled) {
    groups.push({
      heading: 'Navigation',
      rows: [
        { keys: ['j', 'k'], label: 'next / previous story' },
        { keys: ['l', 'Enter'], label: 'open story' },
        { keys: ['o'], label: 'expand story' },
        { keys: ['h'], label: 'toggle shortcuts' },
      ],
    });
  }

  if (
    (pathname === '/tldr' || pathname.startsWith('/search/'))
    && keyboardShortcutsEnabled
  ) {
    groups.push({
      heading: 'Actions',
      rows: [
        { keys: ['y'], label: 'copy story' },
        // Admins spend 'a' on admin mode; 'o' and the arrows still expand.
        ...(isAdminUser ? [] : [{ keys: ['a'], label: 'toggle sources' }]),
        { keys: ['→', '←'], label: 'expand / collapse sources' },
      ],
    });
  }


  return groups;
}
